import { SpeakToTextDto } from 'types';
import { SpeakToTextPosition } from 'types/message-position.type';
import { MESSAGE_SPACING, MESSAGE_SPACING_LARGE } from 'utils/constants';
import { calculateHeightSpeakToTextItem } from './calculateHeightSpeakToTextItem';

export const getPositionsSpeakToTextItems = async (
  messages: SpeakToTextDto[],
  maxMessageWidth = 300,
  isShowName: boolean = true
): Promise<{
  positions: SpeakToTextPosition[];
  height: number;
}> => {
  if (messages.length > 0) {
    let arrPositions = new Array(messages.length).fill({
      height: 50
    });
    let totalHeight = 0;

    for (let index = 0; index < messages.length; index++) {
      const message = messages[index];
      const nextMess = messages[index + 1];
      const prevMess = messages[index - 1];

      const heightMessage = await calculateHeightSpeakToTextItem(
        message,
        nextMess,
        prevMess,
        maxMessageWidth,
        isShowName
      );
      const spacing = message.senderId !== nextMess?.senderId ? MESSAGE_SPACING_LARGE : MESSAGE_SPACING;
      const prevItem = arrPositions[index - 1];
      totalHeight += heightMessage;
      const position = prevItem ? (prevItem.position ? prevItem.position + prevItem.height : prevItem.height) : 0;

      arrPositions[index] = {
        speakToTextId: message.speakToTextId,
        height: heightMessage,
        position,
        spacing
      };
    }

    return {
      positions: arrPositions,
      height: totalHeight
    };
  }
  return {
    positions: [],
    height: 0
  };
};
